import { Clapperboard, Film, Flower2, Palette, Radio, RectangleGoggles } from "lucide-react";
import { SECTIONS, sectionPath } from "@/lib/sections";
import { isCamsPath } from "@/lib/stream-filters";

// What the site shows, as the menu's switch (Sidebar.tsx) and the phone's bar (MobileNav.tsx) offer it:
// the live streams (the home page), the videos, and the sections (lib/sections.ts).

export const MODES = [
  { id: "streams", href: "/", icon: Radio },
  { id: "videos", href: "/videos", icon: Film },
  { id: "shorts", href: "/shorts", icon: Clapperboard },
  { id: "vr", href: sectionPath("vr"), icon: RectangleGoggles },
  { id: "cartoon", href: sectionPath("cartoon"), icon: Palette },
  { id: "hentai", href: sectionPath("hentai"), icon: Flower2 },
] as const;

export type Mode = (typeof MODES)[number]["id"];

/** What a page shows: a section's page (or one under it), the live cams, or else the videos. */
export function modeOf(pathname: string | null): Mode | null {
  if (!pathname) return null;
  if (isCamsPath(pathname)) return "streams";
  if (pathname === "/shorts") return "shorts";
  return SECTIONS.find((s) => pathname === sectionPath(s) || pathname.startsWith(`${sectionPath(s)}/`)) ?? "videos";
}
